import type { RouterConfig } from '@nuxt/schema';
import { useAppConfig } from '#app/config';
import { appendInitialSpaceRoutes } from '#layers/spaces';
import { reservedSlugs } from '#shared/constants/reserved';

export const resolveInitialStudioRoutes: NonNullable<RouterConfig['routes']> = async (studioRoutes) => {
	try {
		// Get project slug from the URL
		const [_, projectSlug] = window.location.pathname.split('/');

		if (projectSlug && !reservedSlugs.includes(projectSlug)) {
			const appConfig = useAppConfig();
			appConfig.monospace.projectSlug = projectSlug;

			return await appendInitialSpaceRoutes(studioRoutes);
		}
	}
	catch (error) {
		console.error('Error fetching spaces:', error);
	}

	return studioRoutes;
};
